
import { Component, Vue, Prop } from 'vue-property-decorator'
import LoadingMask from '@/components/generic/LoadingMask.vue'

@Component({
  components: {
    LoadingMask
  }
})
export default class ItemsTable extends Vue {
  @Prop({ required: true, default: 'item' })
  itemType: string

  @Prop({ required: true, default: [] })
  items: any[]

  @Prop({ required: true })
  mainItemColumns: any[]

  @Prop({ required: false })
  modalItemColumns: any[]

  @Prop({ required: true, default: 'add' })
  mainAction: string

  @Prop({ required: true, default: false })
  available: boolean

  @Prop({ required: true, default: [] })
  allItems: any[]

  @Prop({ required: false, default: 'lg' })
  modalSize: string

  @Prop({ required: false, default: true })
  canAddItems: boolean

  PAGE_SIZE = 500
  loadingRoles = false

  totalItems: number = 0
  search: string = ''
  filteredItems: any[] = []
  selectedItems: string[] = []
  selectedItemIds: number[] = []
  perPage = 10
  currentPage = 1

  totalNewItems: number = 0
  searchNew: string = ''
  filteredNewItems: any[] = []
  selectedNewItems: string[] = []
  selectedNewItemIds: number[] = []
  currentPageSelect = 1

  created () {
    this.selectedItems = []
    this.selectedItemIds = []
  }

  /**
   * Creates modal identifier based on itemType property
   */
  get modalId () {
    return 'modal-select-' + this.itemType
  }

  /**
   * Create title to modal component
   * @returns string title
   */
  get modalTitle () {
    return 'Selección de ' + this.itemType
  }

  /**
   * Get already items filtered
   * @returns items
   */
  get alreadyItems () {
    let alreadyFiltered = this.selectedItems.length > 0 ? this.filteredItems : this.items
    this.totalItems = alreadyFiltered.length
    return alreadyFiltered
  }

  /**
   * Returns new items available to select and add to already items
   * if new items has been selected and already exists on 'items' they will be skipped
   * otherwise will be skipped already items exists on 'items'
   * @returns items available
   */
  get newItemsAvailable () {
    let itemsAvailable = []
    if (this.selectedNewItems.length > 0) {
      itemsAvailable = this.filteredNewItems.filter(it => !this.selectedNewItemIds.includes(it.id) && !this.items.find(item => item.id === it.id))
    } else if (this.allItems.length > 0) {
      itemsAvailable = this.allItems.filter(it => !this.items.find(item => item.id === it.id))
    }
    this.totalNewItems = itemsAvailable.length
    return itemsAvailable
  }

  /**
   * Filter funtion to already items
   */
  onFiltered (filteredItems: any) {
    this.totalItems = filteredItems.length
    this.currentPage = 1
  }

  /**
   * Filter funtion to new items available
   */
  onFilteredNew (filteredNewItems: any) {
    this.totalNewItems = filteredNewItems.length
  }

  /**
   * Add an item to considered to remove from already items
   * @param item to considered remove
   */
  removeItem (item: any) {
    this.selectedItems.push(item.item.id + ':' + item.item.name)
    this.selectedItemIds.push(item.item.id)
    this.filteredItems = this.items.filter(it => !this.selectedItemIds.includes(it.id))
    this.totalItems = this.filteredItems.length
  }

  /**
   * Add an item to considered to add in already items
   * @param item to considered add
   */
  addNewItem (item: any) {
    if (!this.selectedNewItemIds.includes(item.item.id)) {
      this.selectedNewItems.push(item.item.id + ':' + item.item.name)
      this.selectedNewItemIds.push(item.item.id)
      this.filteredNewItems = this.allItems.filter(it => !this.selectedNewItemIds.includes(it.id))
    }
  }

  /**
   * Remove item from considered items to remove
   * @param item to omit
   */
  omitItem (item: any) {
    this.selectedItems.splice(this.selectedItems.indexOf(item), 1)
    this.selectedItemIds.splice(this.selectedItemIds.indexOf(parseInt(item.split(':')[0])), 1)
    this.filteredItems = this.items.filter(it => !this.selectedItemIds.includes(it.id))
  }

  /**
   * Remove item from considered items to add
   * @param item to omit
   */
  omitNewItem (item: any) {
    this.selectedNewItems.splice(this.selectedNewItems.indexOf(item), 1)
    this.selectedNewItemIds.splice(this.selectedNewItemIds.indexOf(parseInt(item.split(':')[0])), 1)
    this.filteredNewItems = this.allItems.filter(it => !this.selectedNewItemIds.includes(it.id))
  }

  /**
   * Display modal component
   */
  addItems () {
    this.$emit('load-items')
    this.$bvModal.show(this.modalId)
  }

  /**
   * Emit event to remove the selected items
   */
  deleteItems () {
    this.$emit('delete-items', this.selectedItemIds)
    this.selectedItems = []
    this.selectedItemIds = []
  }

  /**
   * Emit event to update with new selected items
   */
  updateItems () {
    if (this.selectedNewItems.length > 0) {
      this.$emit('update-items', this.selectedNewItemIds)
      this.selectedNewItems = []
      this.selectedNewItemIds = []
    }
    this.currentPageSelect = 1
    this.$bvModal.hide(this.modalId)
  }

  /**
   * Reset new items arrays
   */
  resetModal () {
    this.filteredNewItems = []
    this.selectedNewItems = []
    this.selectedNewItemIds = []
    this.currentPageSelect = 1
  }
}
